<template>
  <div class="ibox deptMng">
    <div class="ibox-content">
      <div class="flex-row flex-nowrap">
        <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs">
          <el-button type="primary" name="create" @click="handleCreate">新增</el-button>
          <el-button type="primary" :disabled="options.selection.length != 1" @click="handleEditRow">编辑</el-button>
          <el-button type="primary" :disabled="options.selection.length === 0" @click="handleDeleteRow">删除</el-button>
          <el-button type="primary" name="export" @click="handleExport">导出</el-button>
        </div>
      </div>

      <div class="dept-mng-table no-border">
        <r-table
          :ref="tableVarity"
          :dataSource="tableData"
          :options="options"
          :pagination="pagination"
          row-key="id"
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :show-pagination="false"
          @current-change="handlePageChange"
          @row-click="handleRowClick"
        >
          <el-table-column prop="deptName" label="部门名称" class-name="dept-column">
            <template #default="scope">
              <a @click.prevent="handleDetail(scope.row)">{{ scope.row.deptName }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="remark" show-overflow-tooltip label="说明"></el-table-column>
          <el-table-column prop="createTimeStr" label="创建时间"></el-table-column>
          <el-table-column prop="updateTimeStr" label="更新时间"></el-table-column>
        </r-table>
      </div>
    </div>
    <Modal :modalTitle="clickModalType" modalId="deptModal" @show="modalShow = true" @hide="modalShow = false">
      <deptForm
        :formType="clickModalType"
        :deptList="deptList"
        :dept="selectDept"
        :modalShow="modalShow"
        :oper-type="operType"
        @success="submitSuccess"
        :isFill="isFill"
      ></deptForm>
    </Modal>
  </div>
</template>
<script>
import mixin from '@/components/common/tableMixin'
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import DeptItem from './depts/item'
import deptForm from './depts/deptForm'

import { mapActions } from 'vuex'

export default {
  name: 'SystemDept',
  components: {
    deptForm,
    RModal,
    RTable,
  },
  mixins: [mixin, tableMix],
  data() {
    return {
      tableVarity: 'system-dept-mng-table',
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 500
      },

      clickModalType: 'new',
      clickModalContent: '新建部门',
      tableData: [],
      selectDept: null,
      loading: false,
      didInvalidate: false,
      modalShow: false,
      deptList: [],
      defaultProps: {
        children: 'children',
        deptName: 'deptName',
        createTime: 'createTime',
        updateTime: 'updateTime',
      },
      headerID: 0,
      maxHeight: null,
      isFill: false, // 二级部门是否必填
      toExcel:false
    }
  },
  created() {
    //判断是否需要获取数据
    this.getQuery({})
  },
  mounted() {
    this.maxHeight = $('body').height() - $('.deptMng').offset().top - 140
    $('.tree-container').css('maxHeight', this.maxHeight + 'px')
  },
  methods: {
    ...mapActions(['alertToggle']),
    getQuery(params) {
      this._requestData()
      let url = 'DEPT_MNG.GET_DEPTS'
      const _this = this
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          _this._receiveData()
          console.log(res,'ddddddddddddd')
          if(_this.toExcel){
            if (!res.data ) {
              return
            }
            window.location.href = res.data
            return
          }
          _this.toExcel = false
          _this.deptList = res.data
          _this.pagination.total = res && res.count
          _this.tableData = _this._tree(res.data, 0) || []
          this.isFill = res.isFill
          res.data.forEach((item) => {
            if (item.pId === 0) {
              this.headerID = item.id
            }
          })
        })
        .catch((err) => {
          _this._receiveData()
          _this.error = err
          _this.toExcel = false
        })
    },
    handlePageChange(val, opt) {
      this.pagination.pageIndex = val;
      this.pagination.pageSize = opt;
      this._reloadData()
    },
    _reloadData() {
      let params = {
        start: (this.pagination.pageIndex - 1) * this.pagination.pageSize,
        size: this.pagination.pageSize,
        toExcel:this.toExcel,

      }
      if(this.toExcel && this.options.selection.length){
        params.params = JSON.stringify({ids:this.options.selection.map(item => item.id).join(',')})
      }
      //强制请求数据
      this.refreshData()
      this.getQuery(params)
    },
    _tree(data, pid) {
      let result = [],
        temp
      for (var i = 0; i < data.length; i++) {
        if (data[i].pId == pid) {
          var obj = {
            ...data[i],
            children: [],
          }
          temp = this._tree(data, data[i].id)
          if (temp.length > 0) {
            obj.children = temp
          }
          result.push(obj)
        }
      }
      return result
    },
    handleDetail(row) {
      this.clickModalType = '详情'
      this.operType = 'show'
      this.selectDept = row
      $('#deptModal').modal('toggle')
    },
    handleEditRow() {
      this.edit(this.options.selection[0])
    },
    handleDeleteRow() {
      this.$confirm('确定删除当前选中的（' + this.options.selection.length + '条记录）信息吗？', { type: 'warning' })
        .then(() => {
          this.remove(this.options.selection)
        })
        .catch(() => false)
    },
    handleCreate() {
      this.clickModalType = '新增'
      this.operType = 'create'
      let selPId = ''
      if(this.options.selection.length === 1) {
        selPId = this.options.selection[0].id
      }
      this.selectDept = {
        pId: selPId,
        deptName: '',
        remark: '',
      }
      $('#deptModal').modal('toggle')
    },
    append(store, data) {
      this.clickModalType = '新建'
      this.selectDept = {
        pId: data.id,
        deptName: '',
        remark: '',
      }
      $('#deptModal').modal('toggle')
    },
    edit(data) {
      this.clickModalType = '编辑'
      this.operType = 'edit'
      this.selectDept = data
      $('#deptModal').modal('toggle')
    },
    submitSuccess() {
      this.submitFilter()
      $('#deptModal').modal('hide')
    },

    remove(datas) {
      let url = 'DEPT_MNG.DELETE'
      let params = {
        ids: datas.map(item => item.id).join(','),
      }
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          this.alertToggle({
            alertType: 'success',
            alertContent: '删除成功！',
          })
          this._reloadData()
        })
        .catch((err) => {
          this.alertToggle({
            alertType: 'danger',
            alertContent: err,
          })
        })
      $('body').trigger('click')
    },

    renderContent(h, { node, data, store }) {
      return (
        <DeptItem
          data={data}
          appendClick={() => this.append(store, data)}
          removeClick={() => this.remove(store, data)}
          editClick={() => this.edit(store, data, node)}
        />
      )
    },
    handleExport() {
      this.toExcel = true
      this._reloadData()
    },
  },
}
</script>
<style lang="less">
.el-tree {
  border: 0;
}
.create-dept-btn {
  width: 200px;
  margin: 30px auto;
}
.deptMng {
  .tree-container {
    overflow-y: scroll;
  }
  .dept-item {
    font-size: @font-small;
  }
}
.dept-mng-table {
  .dept-column .cell {
    text-align: left;
  }
  .el-table__expand-icon {
    color: white;
  }
}
</style>
